<template>
    <div class="anchorSet">
        <div class="result-list tableList">
            <el-table :data="tableData" style="width: 750px">
                <el-table-column property="" label="主播" width="200">
                    <template slot-scope="scope">
                        <div class="anchorHead">
                            <img class="anchorLogo" :src="scope.row.customerurl" alt="">
                            <span>{{scope.row.customername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="" label="标签设置" class-name="center">
                    <template slot-scope="scope">
                        <div class="noEdit" v-show="!scope.row.istag" @click="edit(scope.row,scope.$index)">{{scope.row.tag}} <img :src="pen" alt=""></div>
                        <div class="editInput" v-show="scope.row.istag">
                            <el-input :ref="'inputEdit-'+scope.$index"  size="mini" @blur="editComplete(scope.row)" v-model="scope.row.tag"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="address" label="接受用户打赏" class-name="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isrcvreaward" :active-value=1 :inactive-value=0 :disabled="isEnd"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column property="address" label="操作" class-name="delText" label-class-name="tr">
                    <template slot-scope="scope">
                        <span  @click="handleDel(scope.row,scope.$index)" v-if="!isEnd">删除</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "liveHeadList",
        props:['tableData','status'],
        data(){
            return{
                pen:require('@/common/images/vliveV2/pen.png'),
                isOpen:'1',
                istagTag:0,
                isShow:false,
                isrcvreaward:false,
                isEnd:false,
            }
        },
        mounted(){
            this.isEnd=[10,100].indexOf(this.status)>=0
            // this.tableData.forEach(obj => {
            //     obj.isrcvreaward=obj.isrcvreaward==1?true:false
            // })
        },
        methods:{
            //主播标签设置
            edit(row,index) {
                if(!this.isEnd){
                    row.istag = 1;
                    this.changeFous(index)
                }
            },
            //编辑完成
            editComplete(row) {
                row.istag = 0
            },
            //输入框聚焦
            changeFous(index){
                this.$nextTick(() => {
                    this.$refs[`inputEdit-${index}`].focus();
                });
            },
            //删除
            handleDel(row,index) {
                this.$confirm(`确认删除该主播吗？`, '提示', {
                }).then(() => {
                    this.tableData.splice(index,1);
                }).catch(() => {})
            },
        }
    }
</script>

<style lang="scss">
    @import "~common/scss/base";
    @import "~common/scss/mixin";
    .anchorSet{
        margin-top: 10px;
        .result-list{
            .anchorHead{
                display: flex;
                align-items: center;
                color: #666;
                .anchorLogo{
                    min-width: 40px;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
            }
            .delText{
                .cell{
                    text-align: right;
                    margin-right: 20px;
                    span{
                        color: #409EFF;
                        cursor: pointer;
                    }
                }
            }
            .noEdit{
                cursor: pointer;
                img{
                    vertical-align: text-top;
                }
            }
            .editInput{
                .el-input{
                    width: 100px;
                }
                .el-input__inner{
                    text-align: center;
                }
            }
            .center{
                .cell{
                    text-align: center;
                }
            }
            .el-table td{
                padding: 0 0;
            }
            .el-table__row {
                height: 60px;
            }
            /*操作标题位置更改*/
            .el-table__header-wrapper .delText > .cell{
                padding-right: 30px;
            }
        }
        /* 设置滚动条的样式 */
        ::-webkit-scrollbar {
            width:8px;
            background-color: #ededed;
        }
        /* 滚动槽 */
        ::-webkit-scrollbar-track {
            border-radius:10px;
        }
        /* 滚动条滑块 */
        ::-webkit-scrollbar-thumb {
            border-radius:10px;
            background:#cccccc;
        }
    }
</style>
